var exports = {
  "kL": "x2b2fbebb--fb9194--container",
  "kb": "x2b2fbebb--fb9194--left",
  "pG": "x2b2fbebb--fb9194--right",
  "mj": "x2b2fbebb--fb9194--like",
  "QZ": "x2b2fbebb--fb9194--dislike",
  "ZF": "x2b2fbebb--fb9194--answer",
  "Jh": "x2b2fbebb--fb9194--answer_visbility",
};

module.exports = exports;
